'use client';

import { config } from '@/configs/configPortal';
import { formatPrice } from '@/helpers/number';
import { ISimilarVersionData } from '@/interfaces/result';
import './versions.scss';

type VersionsProps = {
    versions: ISimilarVersionData[];
    title: string;
    type: string;
};

const Versions = ({ versions, type, title }: VersionsProps) => {

    return (
        <div className="versions" data-testid="versions-container" id="versions-container">
            <h2 className='versions-title' data-testid="versions-title" id="versions-title">Outras versões de {title}</h2>
            <table className='versions-table' data-testid="versions-table" id="versions-table">
                <thead className='versions-table__header' data-testid="versions-table-header" id="versions-table-header">
                    <tr className='versions-table__header-row' data-testid="versions-table-header-row" id="versions-table-header-row">
                        <th className='version-table__header-heading' data-testid="versions-table-header-version" id="versions-table-header-version">Versão</th>
                        <th className='version-table__header-heading' data-testid="versions-table-header-fipe" id="versions-table-header-fipe">Tabela Fipe</th>
                        <th className='version-table__header-heading' data-testid="versions-table-header-webmotors" id="versions-table-header-webmotors">Tabela Webmotors</th>
                    </tr>
                </thead>

                <tbody className='versions-table__body' data-testid="versions-table-body" id="versions-table-body">
                    {versions.map((version) => {
                        const redirectLink = `${config.urlTableFipe}/${type}${version.version_page_path}`;

                        return (
                            <tr className='version-table__row' key={version.version_name} data-testid={`version-row-${version.version_name}`} id={`version-row-${version.version_name}`}>
                                <td className='version-table__data' data-testid={`version-name-${version.version_name}`} id={`version-name-${version.version_name}`}>
                                    <a className="version-table__link" href={redirectLink} data-testid={`version-link-${version.version_name}`} id={`version-link-${version.version_name}`}>
                                        {version.version_name}
                                    </a>
                                </td>
                                <td className='version-table__data'>
                                    {version.fipe_price ? (
                                        <a className="version-table__link" href={redirectLink}>
                                            {formatPrice(version.fipe_price)}
                                        </a>
                                    ) : (
                                        '-'
                                    )}
                                </td>
                                <td className="version-table__data version-price">
                                    {version.average_price ? (
                                        <a className="version-table__link" href={redirectLink}>
                                            {formatPrice(version.average_price)}
                                        </a>
                                    ) : (
                                        '-'
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div >
    );
};

export default Versions;
